import React from "react";
import RecordsEbook from "./RecordsEbook.json";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  CardMedia,
  Button,
  Box,
} from "@mui/material";

const EBooks = () => {
  return (
    <Box
      container
      spacing={3}
      sx={{
        backgroundColor: "transparent",

        flexWrap: "wrap",
        display: "flex",
        padding: " 0px 0px 0px 120px",
      }}
    >
      {RecordsEbook.map((record) => {
        return (
          <>
            <Grid
              sx={{
                margin: 2,
                height: 300,
                width: 187,
                marginBottom: 4,
                alignItems: "center",
              }}
              key={record.id}
            >
              <a href={record.links}>
                <Card
                  sx={{
                    margin: "0 auto",
                    width: 130,
                    backgroundColor: "transparent",
                  }}
                >
                  <CardMedia
                    sx={{
                      height: 160,
                      width: 130,
                    }}
                    image={record.img}
                    title={record.title}
                  />
                </Card>
                <br />
                <Typography
                  sx={{ textAlign: "center" }}
                  variant="body2"
                  color="text.secondary"
                >
                  <b>{record.title} </b>
                </Typography>

                <CardActions>
                  <Button sx={{ margin: "0 auto" }} size="small">
                    Share
                  </Button>
                </CardActions>
              </a>
            </Grid>
          </>
        );
      })}
    </Box>
  );
};

export default EBooks;
